import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiServices } from "../../service/apiServices";

const namespace = "AttendanceMonthly";

export const getAttendanceMonthly = createAsyncThunk(
  `${namespace}/getAttendanceMonthly`,
  async (body, { rejectWithValue }) => {
    const api = "getAttendanceMonthly";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getAttendanceExcelMonth = createAsyncThunk(
  `${namespace}/getAttendanceExcelMonth`,
  async ({ employeeLists, month, year, start_time, end_time, time }, { rejectWithValue }) => {
    const api = "getAttendanceExcelMonth";
    const opt = {
      body: {
        attendance: employeeLists,
        month,
        year,
        start_time, 
        end_time, 
        time
      },
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  searchDetails: {
    month: "",
    year: "",
    start_time: "",
    end_time: "",
    time: "",
    sort: "",
  },
  employeeLists: [],
  loading: false,
  error: false,
};

const attendanceMonthlySlice = createSlice({
  name: "attendanceMonthly",
  initialState,
  reducers: {
    updateSearchDetails(state, action) {
      return { ...state, searchDetails: action.payload };
    },
    resetDetails(state, action) {
      return { ...state, 
        searchDetails: initialState.searchDetails,
        employeeLists: initialState.employeeLists
      };
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getAttendanceMonthly.pending, (state) => {
        state.loading = true;
        state.error = false; // Reset error when starting a new request
      })
      .addCase(getAttendanceMonthly.fulfilled, (state, action) => {
        state.loading = false;
        state.employeeLists = action.payload; // Set employee lists from the response
      })
      .addCase(getAttendanceMonthly.rejected, (state, action) => {
        state.loading = false;
        state.error = true; // Set error state
        console.error(action.payload);
      })

      .addCase(getAttendanceExcelMonth.pending, (state) => {
        state.loading = true;
        state.error = false; // Reset error when starting a new request
      })
      .addCase(getAttendanceExcelMonth.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getAttendanceExcelMonth.rejected, (state, action) => {
        state.loading = false;
        state.error = true; // Set error state
        console.error(action.payload);
      });
  },
});

export const { updateSearchDetails, resetDetails } = attendanceMonthlySlice.actions;
export default attendanceMonthlySlice.reducer;